if (!customElements.get('product-quick-add')) {
  class ProductQuickAdd extends window.BAO.CustomElement() {
    setupListeners () {
      super.setupListeners()

      if (typeof this.els?.selector?.element === 'undefined') return

      this.listeners.add(
        this.els.selector.element,
        'change',
        this.handleSelectorChange.bind(this),
      )
    }

    /** @param {Event} event */
    handleSelectorChange (event) {
      const [selectedOption] = event.currentTarget.selectedOptions
      const { buttonLabel } = selectedOption.dataset

      this.els.submit.element.disabled = false
      this.els.submitLabel.element.textContent = buttonLabel
    }
  }
  customElements.define('product-quick-add', ProductQuickAdd)
}
